import { useEffect } from "react";
import { trackEvent } from "@/lib/analytics";

/**
 * Global scroll-depth tracker. Fires `scroll_75` once per page load
 * when the user scrolls past 75% of the document height.
 */
const ScrollDepthTracker = () => {
  useEffect(() => {
    let fired = false;
    let ticking = false;
    const check = () => {
      ticking = false;
      if (fired) return;
      const doc = document.documentElement;
      const scrolled = window.scrollY + window.innerHeight;
      const total = doc.scrollHeight;
      if (total <= 0) return;
      if (scrolled / total >= 0.75) {
        fired = true;
        trackEvent("scroll_75", { page_path: window.location.pathname });
        window.removeEventListener("scroll", onScroll);
      }
    };
    const onScroll = () => {
      if (ticking || fired) return;
      ticking = true;
      window.requestAnimationFrame(check);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return null;
};

export default ScrollDepthTracker;
